import { render, staticRenderFns } from "./hr_business_info.vue?vue&type=template&id=0c61121a&scoped=true"
import script from "./hr_business_info.vue?vue&type=script&lang=js"
export * from "./hr_business_info.vue?vue&type=script&lang=js"
import style0 from "./hr_business_info.vue?vue&type=style&index=0&id=0c61121a&prod&lang=css"
import style1 from "./hr_business_info.vue?vue&type=style&index=1&id=0c61121a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61121a",
  null
  
)

export default component.exports